import type { GetSigninResponse } from '../get';
import {
	postGenericEndpoint,
	type PostGenericEndpointParams,
} from './post.api';
import type { PostSigninRequest } from './types';

export const postSignin = async ({
	data,
	lang,
	token,
}: PostGenericEndpointParams<PostSigninRequest>): Promise<GetSigninResponse> => {
	return await postGenericEndpoint({
		data,
		lang,
		token,
		path: 'signin',
	});
};
